<template>
  <div id="role_list">
    <div :class="`loader${loaderClass}`" v-show="loading">
    </div>
    <div id="page-content-wrapper" class="admin-content-area">
      <template v-if="cantAccessPage === true">
        <div class="page-name">
          <div class="page-title"> Role List</div>
          <router-link v-if="canAddRole" class="btn btn-primary pull-right" v-bind:to="{name: 'RoleCreate'}"><i
            class="fp-add"> </i> Add
          </router-link>
        </div>
        <div class="container-fluid">
          <div class="admin-page-content role-list">
            <data-table-filter-config :moduleName="'rolelist'" @cancelSelection="cancelAll"
                                      :allowSameFilter="'allow'"></data-table-filter-config>
            <section class="data-table bg-white">
              <custom-pagination
                :page-changed="onPageChange"
                :per-page-changed="onPerPageChange" :moduleName="'rolelist'" :position="'top'">
              </custom-pagination>

              <vue-good-table
                ref="listRoleTable"
                mode="remote"
                title="Role"
                @on-page-change="onPageChange"
                @on-selected-rows-change="selectionChanged"
                @on-column-filter="onColumnFilter"
                @on-per-page-change="onPerPageChange"
                @on-sort-change="onSortChange"
                :totalRows="totalRecords"
                :columns="userColumns"
                :rows="rows"
                :pagination-options="{
                                        enabled: false,
                                        position: 'both',
                                        perPage: perPage,
                                        perPageDropdown:dropDownPerPage,
                                        dropdownAllowAll: false,
                                    }"
                :search-options="{
                                    enabled: false,
                                    }">

                <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                  <div :key="key">
                    <div v-if="props.column.field == 'action'">
                      <template v-if="canUpdateRole">
                        <router-link title="Edit Role" class="fp-edit"
                                     v-bind:to="{name: 'RoleEdit',params:{id:props.row.id}}"></router-link>
                      </template>
                    </div>
                    <div v-else>
                      {{ props.formattedRow[props.column.field] }}
                    </div>
                  </div>
                </template>
              </vue-good-table>
              <custom-pagination
                :page-changed="onPageChange"
                :per-page-changed="onPerPageChange">
              </custom-pagination>
            </section>
          </div>
        </div>
      </template>
      <template v-else-if="cantAccessPage === false">
        <div class="container-fluid">
          <div class="bg-white text-center">
            <h1>
              Oops!</h1>
            <h2>
              403 </h2>
            <div class="error-details">
              Sorry!, You don't have permission to access this page.
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <loading-content></loading-content>
      </template>
      <app-footer></app-footer>
    </div>

  </div>
</template>
<script>
import Vue from "vue";
import EventBus from "././event-bus";
import {commonMixins} from '../mixins/commonMixins';
import {dataTableMixins} from '../mixins/dataTableMixins';

export default {
  name: "RoleList",
  metaInfo() {
    return {title: "Role List | " + process.env.COPYRIGHT_NAME}
  },
  mixins: [commonMixins, dataTableMixins],
  data: () => ({
    permissions: [],
    cantAccessPage: "",
    firstLoad: 0,
    userColumns: [],
    columns: [
      {
        label: 'Actions',
        field: 'action',
        sortable: false,
        hidden: false,
      },
      {
        label: 'Role Name',
        field: 'name',
        filterable: true,
        fpFieldType: "text",
        hidden: false,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Name", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: 'Role Identifier',
        field: 'slug',
        filterable: true,
        fpFieldType: "text",
        hidden: false,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Role Identifier", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: 'Is Corporate',
        field: 'is_corporate',
        fpFieldType: "option",
        filterable: true,
        filterOptions: {
          filterDropdownItems: ['Yes', 'No'],
        },
      },
    ],
    rows: [],
    totalRecords: 0,
    loading: false,
    canUpdateRole: false,
    canAddRole: false,
  }),
  watch: {
    //check permission change
    permissions: function (permissions) {

      var self = this;
      if (permissions.length > 0) {
        for (var i = 0; i < permissions.length; i++) {
          if (permissions[i].name == 'list_role') {
            self.cantAccessPage = true;
          }
          if (permissions[i].name == 'add_role') {
            self.canAddRole = true;
            self.canUpdateRole = true;

          }
          // if (permissions[i].name == 'update_role') {
          // }
        }
      }

    }
  },
  created: function () {

  },
  beforeMount: function () {
    var self = this;
    self.getPermissions();
  },
  mounted: function () {
    var self = this;

    //self.loadList();
  },
  methods: {
    cancelAll: function (cancelAll) {
      this.$refs.listRoleTable.unselectAllInternal();
    },

    selectionChanged(param) {
      var self = this;
      if (param.selectedRows.length == 100) {
        EventBus.$emit('clear-selection', false);
      } else {
        EventBus.$emit('clear-all-flags', false);
      }
    },

    loadList() {
      var self = this;
      self.loading = true;
      var fields = {
        page: self.serverParams.page,
        perPage: self.serverParams.perPage,
        filters: self.serverParams.columnFilters,
        // messageData: self.message,
        sort: self.serverParams.sort,
        // exportFiltered: self.exportFilteredFlag
      };
      self.firstLoad = 1;
      $.ajax({
        url: process.env.ROOT_API + "/role/list",
        type: "POST",
        data: fields,
        headers: this.ajxHeaders,
        dataType: "json",
        success: function (data) {
          self.loading = false;
          if (data.status == "success") {
            self.rows = data.content.row;
            self.totalRecords = data.content.totalRecords;
            self.filteredFlag = false;
          }
        },
        error: function (jqXHR, exception) {
          self.loading = false;
          self.generateStatusCodeMessage(jqXHR, false, 'role-list')
        }
      });
    },

  }
};
</script>



// WEBPACK FOOTER //
// src/components/RoleList.vue